import styled from 'styled-components';

export const Menu = styled.div`
	z-index: 10000;
	position: absolute;
	top: 75px;
	right: 1%;
	background-color: #fff;
	border-radius: 6px;
	border: 1px solid #dee2e6;
	color: #6c757d;

	ul {
		padding: 0;
		margin: 0;
		padding: 3.5px 0px;
		li {
			padding: 3.5px 17.5px;
			list-style: none;
			line-height: 35px;
			a {
				color: #6c757d;
				text-decoration: none;

				margin-left: 7px;
			}

			select {
				border: none;
				color: #6c757d;
				margin-left: 7px;
				cursor: pointer;
			}
		}

		hr {
			margin-top: 9px;
			margin-bottom: 0px;
		}
	}
`;
